import { addTariffCodesToMembers } from '@/utils/utils'
import { defineStore } from 'pinia'


export const useSunsetStore = defineStore('sunsetStore', {
  state: () => ({
    members: [],
    tariffCodes: [],
    sunset: null as any | null,
  }),

  actions: {  
    setMembers(members: any) {
      this.members = members
    },

    setTariffCodes(tariffCodes: any) {
      this.tariffCodes = tariffCodes
    }
  }
})